import { OpenNewTabTargetType } from "@voltmoney/types";
import { onTrackCustomerByToken } from "../partnerWeb_Dashboard/utils";
import { StoreKey } from "../../configs/api";
import { ROUTE } from "../../routes";
import AsyncStorage from "@react-native-async-storage/async-storage";
const tableSearchString = "";
// export const mockDATA = MockDataJson;
const searchIndex = [];
export const TestAction = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    // console.warn("**** Test Action Triggered ****", action);
};
export const onLoadAction = async (action, _datastore, { navigate, goBack, setDatastore }) => {
    // const  userId = await sharedPropsService.getUser();
    // console.log("asdawdaw: ", action.payload.value);
    // if(action.payload.value) {
    //     onTrackCustomer(action.payload.value);
    // }
};
export const onClosePopup = async (action, _datastore, { hidePopup, asyncStorage, removeWidgets, instrumentTrack, navigate }) => {
    console.warn("**** onClosePopup Action Triggered ****", action);
    const currentActiveTabIndex = action?.payload?.currentActiveTabIndex;
    const currentPage = action?.payload?.currentPage;
    const searchContext = action?.payload?.searchContext;
    await asyncStorage.set(StoreKey.PLJ_borrowerAccountId, '');
    await asyncStorage.set('u_data', null);
    await instrumentTrack('PLJ_CLOSE_BUTTON_CLICKED');
    if (currentActiveTabIndex !== undefined) {
        await navigate(ROUTE.PARTNER_LEAD, { currentPendingCustomerActiveTabIndex: currentActiveTabIndex, currentPage, searchContext });
    }
    else
        await hidePopup();
};
export const goToRegisterLeads = async (action, _datastore, { hidePopup, navigate }) => {
    console.warn("**** goToRegisterLeads Action Triggered ****", action);
    await hidePopup();
    const phoneNumber = action?.payload?.data?.data?.user_data?.phoneNumber;
    const pan = action?.payload?.data?.data?.user_data?.panNumber;
    await navigate(ROUTE.REGISTER_LEADS, { phoneNumber: phoneNumber, pan: pan, preFill: true });
};
export const onPLJLoadCompleteAction = async (action, _datastore, { network, asyncStorage, instrumentTrack }) => {
    console.warn("**** onPLJLoadCompleteAction Action Triggered ****", action);
    const trackingId = await AsyncStorage.getItem('trackingId');
    instrumentTrack('PLJ_APP_BUNDLE_LOADING_COMPLETED', { trackingId: trackingId });
    const pldId = action?.payload?.pldId;
    const isFromCheckLimitMFC = action?.payload?.isFromCheckLimitMFC;
    if (isFromCheckLimitMFC)
        return;
    await onTrackCustomerByToken(pldId, network, asyncStorage, { instrumentTrack });
};
export const onShareLinkAction = async (action, _datastore, { openNewTab, asyncStorage }) => {
    const link = action.payload.link;
    const partnerName = action.payload.userFullName;
    const partnerInterestRate = action?.payload?.partnerInterestRate;
    console.warn("**** onPLJLoadCompleteAction Action Triggered ****", action);
    const url = `https://api.whatsapp.com/send?text=Hi%2c%20Use%20Volt%20Money%20to%20open%20a%20credit%20line(OD)%20against%20mutual%20funds%20in%20just%205%20minutes%2e%20Use%20this%20link%20to%20apply%20now%2e%0a${link}%0aRegards%2c%0a${encodeURIComponent(partnerName)}`;
    openNewTab(url, OpenNewTabTargetType.blank);
};
export const onCopyLinkAction = async (action, _datastore, { openNewTab, setDatastore, clipboard }) => {
    const link = action.payload.link;
    const partnerName = action.payload.userFullName;
    const partnerInterestRate = action?.payload?.partnerInterestRate;
    console.warn("**** onPLJLoadCompleteAction Action Triggered ****", action);
    await setDatastore(ROUTE.VOLT_APP, 'pljJourneyPage', {
        copyLinkText: 'Link copied'
    });
    clipboard.set(link);
    setTimeout(async () => {
        await setDatastore(ROUTE.VOLT_APP, 'pljJourneyPage', {
            copyLinkText: 'Copy link'
        });
    }, 2000);
};
